import React from "react";
import { useHistory, Redirect } from "react-router-dom";
import useTokenValidation from "../hooks/useTokenValidation";

const AuthGuard = ({ children, type }) => {

  const history = useHistory();
  
  let token = "";
  let userId = "";
  let url = ""
  let role = ""
  
  if (type === "user") {
    token = localStorage.getItem("user.token");
    userId = localStorage.getItem("user.id");
    role = localStorage.getItem("user.role");
  }else if(type === 'consultant'){
    token = localStorage.getItem("consultant.token");
    userId = localStorage.getItem("consultant.id");
    role = localStorage.getItem("consultant.role");
  } else if (type === "candidate") {
    token = localStorage.getItem("candidate.token");
    userId = localStorage.getItem("candidate.id");
    role = localStorage.getItem("candidate.role");
  }

  if(type === 'user'){
    url = `/login?continueTo=${history.location.pathname}${history.location.search}`
  }else if(type === 'consultant'){
    url = `/consultant?continueTo=${history.location.pathname}${history.location.search}`
  }else if(type === 'candidate'){
    url = `/careers?continueTo=${history.location.pathname}${history.location.search}`
  }

  // const {loading} = useTokenValidation(type);

  // if(loading){
  //   return <></>;
  // }

  if ((!token || !userId)) {
    return (
      <Redirect
        to={url}
      />

      // <div style={styles.container}>
      //   <h2 style={styles.title}>Not Authorized</h2>
      //   <p style={styles.message}>
      //     You do not have permission to access this page. Please log in to
      //     continue.
      //   </p>
      //   <button
      //     className={"btn btn-primary"}
      //     type="submit"
      //     onClick={() => {
      //       window.location.replace(
      //         type === "user"
      //           ? `/?continueTo=${history.location.pathname}`
      //           : `/careers?continueTo=${history.location.pathname}`
      //       );
      //     }}
      //   >
      //     Continue to login
      //   </button>
      // </div>
    );
  }

  return <div>{children}</div>;
};

// const styles = {
//   container: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "90dvh",
//     color: "#333",
//     padding: "0 20px",
//     textAlign: "center",
//   },
//   title: {
//     fontSize: "2rem",
//     marginBottom: "10px",
//   },
//   message: {
//     fontSize: "1.2rem",
//     marginBottom: "20px",
//   },
// };

export default AuthGuard;
